import { render, staticRenderFns } from "./donut-chart-widget.vue?vue&type=template&id=57ce895c&scoped=true&"
import script from "./donut-chart-widget.vue?vue&type=script&lang=js&"
export * from "./donut-chart-widget.vue?vue&type=script&lang=js&"
import style0 from "./donut-chart-widget.vue?vue&type=style&index=0&id=57ce895c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ce895c",
  null
  
)

component.options.__file = "donut-chart-widget.vue"
export default component.exports